import React from 'react';
import Button from 'components/CustomButtons/Button';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/prepaidLoyalty/cardButtonsStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ICardButtons {
	buttons: types.prepaidLoyalty.IButton[];
}

const CardButtons = ({ buttons }: ICardButtons) => {
	const classes = useStyles();

	return (
		<div className={classes.buttonsWrapper}>
			{buttons.map((button, index) => (
				<Button key={index} color={button.color} onClick={button.onClick} disabled={button.disabled}>
					{button.text}
				</Button>
			))}
		</div>
	);
};

export default CardButtons;
